export default __webpack_public_path__ + "static/media/data_processing.e617a996.svg";